import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type Currency = 'EUR' | 'USD' | 'CAD' | 'GBP' | 'CHF'

export const CURRENCIES: { code: Currency; label: string; symbol: string }[] = [
  { code: 'EUR', label: 'Euro', symbol: '€' },
  { code: 'USD', label: 'US Dollar', symbol: '$' },
  { code: 'CAD', label: 'Dollar Canadien', symbol: 'C$' },
  { code: 'GBP', label: 'Livre Sterling', symbol: '£' },
  { code: 'CHF', label: 'Franc Suisse', symbol: 'CHF' },
]

interface CurrencyState {
  currency: Currency
  setCurrency: (c: Currency) => void
}

export const DEFAULT_CURRENCY: Currency = 'CAD'

export const useCurrencyStore = create<CurrencyState>()(
  persist(
    (set) => ({
      currency: DEFAULT_CURRENCY,
      setCurrency: (c) => set({ currency: c }),
    }),
    { name: 'sgrc-currency' },
  ),
)

export function formatCurrency(
  amount: number | null | undefined,
  currency: Currency = DEFAULT_CURRENCY,
  locale = 'fr-CA',
): string {
  if (amount == null || isNaN(amount)) return '—'
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      maximumFractionDigits: 0,
    }).format(amount)
  } catch {
    return `${amount.toLocaleString(locale)} ${currency}`
  }
}
